var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.14,
    height: 27.087,
    viewBox: "0 0 26.14 27.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5716",
    "data-name": "Group 5716",
    transform: "translate(-5697.771 1803.166)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5838",
    "data-name": "Line 5838",
    x2: 25.572,
    y2: 26.541,
    transform: "translate(5698.054 -1802.893)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 0.787
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5839",
    "data-name": "Line 5839",
    x1: 25.572,
    y2: 26.541,
    transform: "translate(5698.054 -1802.893)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 0.787
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ab5554f41a5ab7cb553702d8975f3a58.svg";
export { ForwardRef as ReactComponent };